import * as types from 'modules/interventions/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *  [interventionId: string]: {
 *    loading: boolean,
 *    data: import("modules/interventions/types/projections/detailed-kanban-intervention").DetailedKanbanIntervention
 *  }
 * }} InterventionKanbanDetailsReducer
 */
const initialState = {};

/**
 * @param {InterventionKanbanDetailsReducer} state
 */
const onFetchIntervention = (state, { payload }) => {
  const { interventionId } = payload;

  return {
    ...state,
    [interventionId]: {
      ...state[interventionId],
      loading: true,
    },
  };
};

/**
 * @param {InterventionKanbanDetailsReducer} state
 */
const onFetchInterventionSuccess = (state, { payload }) => {
  const { id: interventionId } = payload;
  return {
    ...state,
    [interventionId]: {
      ...state[interventionId],
      loading: false,
      data: payload,
    },
  };
};

/**
 * @param {InterventionKanbanDetailsReducer} state
 */
const onFetchInterventionFailure = (state, { payload }) => {
  const { interventionId } = payload;
  return {
    ...state,
    [interventionId]: {
      ...state[interventionId],
      loading: false,
    },
  };
};

export default createReducer(initialState, {
  [types.FETCH_KANBAN_INTERVENTIONS]: () => initialState,
  [types.FETCH_INTERVENTION_KANBAN_DETAILS_REQUEST]: onFetchIntervention,
  [types.FETCH_INTERVENTION_KANBAN_DETAILS_SUCCESS]: onFetchInterventionSuccess,
  [types.FETCH_INTERVENTION_KANBAN_DETAILS_FAILURE]: onFetchInterventionFailure,
});
